export const featuredConstants = {
    FEATURED_CELEBS_REQUEST: 'FEATURED_CELEBS_REQUEST',
    FEATURED_CELEBS_SUCCESS: 'FEATURED_CELEBS_SUCCESS',
    FEATURED_CELEBS_FAILURE: 'FEATURED_CELEBS_FAILURE',
};
